import script from "./AppointmentItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentItem.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentItem.vue?vue&type=style&index=0&id=c604a986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c604a986"]])

export default __exports__